import React from 'react';
import PropTypes from 'prop-types';
import { Link } from "react-router-dom";
import { app } from '../../../values/ui';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';
import TwoLineEllipsis from '../../TwoLineEllipses';

const SplashScreen = ({ onClick, blocks, title, translate }) => {
  const {t} = useTranslation('reports');

  const splashClick = (link) => {
    onClick && onClick(link)
  }

  return (
    <div className="reports-menu">
      <div className="reports-splash-header">
        {translate ? t(title) : title}
      </div>
      <div className="reports-splash-container">
        {blocks.map((bl, i) => (
          <SplashBlock
            key={`${bl.type}`}
            type={bl.type}
            icon={bl.icon}
            link={bl.link}
            onClick={splashClick}
            label={bl.label}
            subtext={bl.subtext}
            tagline={bl.tagline}
            translate={translate}
          />
        ))}
      </div>
    </div>
  )
}

SplashScreen.propTypes = {
  onClick: PropTypes.func
}

const SplashBlock = ({type, icon, link, onClick, label, subtext, tagline, translate}) => {

  const {t} = useTranslation('reports');

  const splashClick = () => {
    onClick && onClick(link)
  }
  const blockClassName = label && label.replace(/\s/g, '-').toLowerCase();
  
  const splashBlockLinkStyle = cx({
    'reports-splash-block': true,
  }, blockClassName);

  const splashBodyStyle = cx({
    'reports-splash-block-body': true,
    'noIcon': icon ? false : true,
  });

  return (
    <Link to={link} className={splashBlockLinkStyle}>
        {icon && (
          <div alt={type} className="reports-splash-block-img">
            <SplashIcon icon={icon}/>
          </div>
        )}
        <div className={splashBodyStyle}>
          <div className="reports-splash-block-header">{translate ? t(`${type}_label`) : label}</div>
          <div className="reports-splash-subtext">{translate ? t(`${type}_description`) : subtext}</div>
          <div className="reports-splash-tagline">
            <TwoLineEllipsis>{translate ? t(`${type}_tagline`) : tagline}</TwoLineEllipsis>
          </div>
        </div>
    </Link>
  )
}

SplashBlock.propTypes = {
  label: PropTypes.string,
  img: PropTypes.string,
  link: PropTypes.string,
  onClick: PropTypes.func,
  className: PropTypes.string
}

/**
 * Renders the icon based on the icon type.
 * @param {icon} param0 take an icon parameter, it can be either a react svg component or an image import (uri)
 * @returns a rendered icon
 */
const SplashIcon = ({icon}) => {
  if(!icon) return null
  if(typeof icon === 'function') return icon()
  if(typeof icon === 'string') return <img className='icon-image' src={icon}/> // assumes string is a valid uri
  return null
}

export default SplashScreen;